var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./index.vue"),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/packages/upload/src/index.vue
// module id = 382
// module chunks = 1